ACC.schaeffGA = {

    _autoload: [
        "bindFooterLinks",
        "bindPlpInteractions",
        "bindTileComponentInteractions",
        "bindHomepageInteractions",
    ],

    bindFooterLinks: function () {
        if (window.dataLayer) {
            $('.js__gs-footer-link').on('click', function (e) {
                const label = $(this).data('ga-name');
                dataLayer.push({
                    'event': 'gaEvent',
                    'eventCategory': 'Navigation',
                    'eventAction': 'Footer',
                    'eventLabel': label,
                })
            });
        }


    },
    bindPlpInteractions: function () {
        const isPlpPage = $('.js__page-plp').length === 1;
        if (isPlpPage && window.dataLayer) {
            // button on image header component
            $('.js-jsp__image-header__btn').on('click', function (e) {
                dataLayer.push({
                    'event': 'gaEvent',
                    'eventCategory': 'PLP & Search Interactions',
                    'eventAction': 'PLP - More Information',
                    'eventLabel': window.SCHA.pageCategory,
                });
            });
        }
    },
    bindTileComponentInteractions: function () {
        if (window.dataLayer) {
            $('.js-jsp__page-pgp a.js-jsp__tile-component').on('click', function (e) {
                const tileComponent = $(this).closest('.js-jsp__tile-component');
                const category = tileComponent.data('category');
                const subCategory = tileComponent.data('sub-category');
                dataLayer.push({
                    'event': 'gaEvent',
                    'eventCategory': 'PGP Interactions',
                    'eventAction': 'Level 1: ' + category,
                    'eventLabel': 'Level 2: ' + subCategory
                });
            });
        }
    },
    bindHomepageInteractions: function () {
        if (window.dataLayer && document.querySelector('.page-homepage')) {
            // Carousel
            $('.page-homepage [data-ga-name][data-type=rotatingimagescomponent]').on('click', function (e) {
                const name = $(this).data('ga-name');
                const index = ACC.schaeffGA.findChildIndex(this.parentElement) + 1;
                if (dataLayer) {
                    dataLayer.push({
                        'event': 'promotionClick',
                        'ecommerce': {
                            'promoClick': {
                                'promotions': [
                                    {
                                        'name': name,
                                        'creative': 'Main Teaser',
                                        'position': 'Slot ' + index
                                    }]
                            }
                        }
                    });
                }
            });
            // Tiles
            $('.page-homepage a.js-jsp__tile-component').on('click', function (e) {
                const tileComponent = $(this).closest('.js-jsp__tile-component');
                const category = tileComponent.data('category');
                const allTiles = Array.prototype.slice.call(document.querySelectorAll('.page-homepage .js-jsp__tile-component'));
                const index = allTiles.indexOf(this) + 1;
                if (dataLayer) {
                    dataLayer.push({
                        'event': 'promotionClick',
                        'ecommerce': {
                            'promoClick': {
                                'promotions': [
                                    {
                                        'name': category,
                                        'creative': 'Content Box',
                                        'position': 'Slot ' + index
                                    }]
                            }
                        }
                    });
                }

            });

            const isElementVisible = ACC.schaeffGA.isElementVisible;

            // Impressions
            (function () {

                // Impression - carousel
                const seenCarouselTiles = {};
                ACC.schaHomepageCarousel.addOnNextCallback(function (index, tileElement) {
                    if (!seenCarouselTiles[index]) {
                        if (isElementVisible(tileElement)) {
                            seenCarouselTiles[index] = true;
                            if (tileElement) {
                                const gaElement = tileElement.querySelector('ga-name');
                                const name = $(gaElement).data('ga-name');
                                if (dataLayer) {
                                    dataLayer.push({
                                        'event': 'promotionImpression',
                                        'ecommerce': {
                                            'promoView': {
                                                'promotions': [
                                                    {
                                                        'name': name,
                                                        'creative': 'Main Teaser',
                                                        'position': 'Slot ' + (index + 1)
                                                    }
                                                ]
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });

                // Impression - tile

                var timeoutId = 0;
                var lastTileImpressionSeen = 0;
                var getImpressions = function () {
                    const elements = Array.prototype.slice.call(document.querySelectorAll('.page-homepage .js-jsp__tile-component'), lastTileImpressionSeen);
                    var newLastSeen = lastTileImpressionSeen;
                    const tileImpressions = [];
                    for (var i = 0; i < elements.length; i++) {
                        if (isElementVisible(elements[i])) {
                            newLastSeen++;
                            const category = $(this).data('category');
                            tileImpressions.push({
                                'name': category,
                                'creative': 'Content Box',
                                'position': 'Slot ' + newLastSeen
                            });
                        } else {
                            break;
                        }
                    }
                    if (tileImpressions.length > 0 && dataLayer) {
                        dataLayer.push({
                            'event': 'promotionImpression',
                            'ecommerce': {
                                'promoView': {
                                    'promotions': tileImpressions
                                }
                            }
                        });
                    }
                };

                window.addEventListener('scroll', function (e) {
                    clearTimeout(timeoutId);
                    timeoutId = setTimeout(getImpressions, 250);
                });
            })();


        }
    },

    isElementVisible: function (element) {
        const dimensions = element.getBoundingClientRect();
        return -window.innerHeight + dimensions.top + dimensions.height / 4 <= 0;

    },

    registerRecentlyViewedComponentsClick: function (productDesignation, elementIndex) {
        if (window.dataLayer) {
            dataLayer.push({
                'event': 'promotionClick',
                'ecommerce': {
                    'promoClick': {
                        'promotions': [
                            {
                                'name': productDesignation,
                                'creative': 'Recently viewed products',
                                'position': 'Slot ' + elementIndex
                            }]
                    }
                }
            });
        }
    },

    findChildIndex: function (el) {
        const children = el.parentElement.children;
        for (let i = 0; i < children.length; i++) {
            if (children[i] === el) return i;
        }
    },
};

